"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign = void 0;
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./memoize"), exports);
(0, tslib_1.__exportStar)(require("./memoizeProjectors"), exports);
(0, tslib_1.__exportStar)(require("./memThunk"), exports);
var signature_1 = require("./signature");
Object.defineProperty(exports, "sign", { enumerable: true, get: function () { return signature_1.sign; } });



//////////////////
// WEBPACK FOOTER
// ./src/memoize/index.ts
// module id = 22
// module chunks = 0